import { AuthorizePreviewRoute, HomeRouteIndex, LoginResponseRoute, LoginRoute } from "@/routes/auth/authRoutes.tsx"
import { InvitationRoute } from "@/routes/invitations/invitationRoutes.tsx"
import {
  NewProjectRoute,
  ProjectHomeRoute,
  ProjectRootRoute,
  ProjectSettingsRoute,
  ProjectsIndexRoute,
  ProjectsRoute,
} from "@/routes/projects/projectsRoutes.tsx"
import { MyOrgsRoute } from "@/routes/root/MyOrgsRoute.tsx"
import { OrgRoute, ReservedRoute, RootRoute } from "@/routes/root/RootRoute.tsx"
import { SandboxRoute, SandboxRouteIndex } from "@/routes/sandbox/sandboxRoutes.tsx"
import { TasksRoute, TasksRouteIndex, TasksRouteNewTask, TasksRouteViewTask } from "@/routes/tasks/tasksRoutes.tsx"
import { UserProfileRoute, UserSettingsRoute } from "@/routes/user/userRoutes.tsx"

export const routeTree = RootRoute.addChildren([
  MyOrgsRoute,

  ReservedRoute.addChildren([
    LoginRoute,
    LoginResponseRoute,
    InvitationRoute,
  ]),

  OrgRoute.addChildren([
    AuthorizePreviewRoute,
    HomeRouteIndex,
    UserProfileRoute,
    UserSettingsRoute,

    ProjectsRoute.addChildren([
      ProjectsIndexRoute,
      NewProjectRoute,
      ProjectRootRoute.addChildren([
        ProjectHomeRoute,
        ProjectSettingsRoute,

        TasksRoute.addChildren([
          TasksRouteIndex,
          TasksRouteNewTask,
          TasksRouteViewTask,
        ]),
      ])
    ]),

    SandboxRoute.addChildren([
      SandboxRouteIndex,
    ]),
  ])
])